import { DISPLAY_HEADER_IN_DESKTOP, DISPLAY_HEADER_IN_MOBILE } from 'definitions/layout';

export const isHeaderVisibility = (routeName, isMobile) => isMobile
  ? DISPLAY_HEADER_IN_MOBILE.includes(routeName)
  : DISPLAY_HEADER_IN_DESKTOP.includes(routeName);
